import { render, staticRenderFns } from "./ScoreboardFO.vue?vue&type=template&id=2a072ae4"
import script from "./ScoreboardFO.vue?vue&type=script&lang=js"
export * from "./ScoreboardFO.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardFO.vue?vue&type=style&index=0&id=2a072ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports